import { render, staticRenderFns } from "./SyncWithConnect.vue?vue&type=template&id=5d283d88&scoped=true"
import script from "./SyncWithConnect.vue?vue&type=script&lang=js"
export * from "./SyncWithConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d283d88",
  null
  
)

export default component.exports